import classNames from "classnames";
import { useTranslations } from "next-intl";

import useSubscriptions from "~/hooks/use-subscriptions";

import styles from "./loyalty-progress.module.scss";

export default function LoyaltyProgress() {
  const t = useTranslations();
  const { loyaltyPoints, loyaltyTierThresholds } = useSubscriptions();
  const minThreshold = loyaltyTierThresholds.find((t) => t > 0)!;
  const maxThreshold = loyaltyTierThresholds.at(-1)!;
  const points = loyaltyPoints ?? 0;
  const progress = Math.min(points / maxThreshold, 1);
  const mappedThresholds = loyaltyTierThresholds.length
    ? Array.from({ length: Math.floor(maxThreshold / minThreshold) + 1 })
    : [];

  return (
    <div className={styles.progressBarContainer}>
      <div className={styles.progressBarWrapper}>
        <div
          className={styles.progressBar}
          role="progressbar"
          aria-label={t("generic.loyaltyPoints", { points })}
          aria-valuemin={0}
          aria-valuemax={maxThreshold}
          aria-valuenow={points}
        >
          <span className={styles.progressValue} style={{ width: `${progress * 100}%` }} />
          <div className={styles.checkpoint} style={{ marginInlineStart: `calc(${progress * 100}% - 8px)` }} />
        </div>
      </div>
      <div
        style={{
          gridTemplateColumns: `1fr repeat(${Math.floor(maxThreshold / minThreshold) - 1}, 2fr) 1fr`,
        }}
        className={styles.progressBarLabels}
      >
        {mappedThresholds.map((_, index) => {
          const tier = index * minThreshold;
          const isTier = loyaltyTierThresholds.includes(tier);

          return (
            <div key={index} className={styles.progressBarLabelsWrapper}>
              {isTier && (
                <>
                  <div className={styles.verticalLine} />
                  <div className={classNames(styles.number)}>{tier}</div>
                </>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
